export const tapesUploadedPanelClass = 'flex-1';
